export const MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export const DAYS = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];

export const rupiah = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(n || 0);

export const formatDate = (iso) => {
  if (!iso) return "-";
  const [y, m, d] = iso.split("-").map(Number);
  return `${d} ${MONTHS[m - 1]} ${y}`;
};

export function terbilang(n) {
  const angka = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];
  n = Math.floor(Math.abs(n));
  let hasil = "";
  if (n < 12) hasil = " " + angka[n];
  else if (n < 20) hasil = terbilang(n - 10) + " Belas";
  else if (n < 100) hasil = terbilang(Math.floor(n / 10)) + " Puluh" + terbilang(n % 10);
  else if (n < 200) hasil = " Seratus" + terbilang(n - 100);
  else if (n < 1000) hasil = terbilang(Math.floor(n / 100)) + " Ratus" + terbilang(n % 100);
  else if (n < 2000) hasil = " Seribu" + terbilang(n - 1000);
  else if (n < 1000000) hasil = terbilang(Math.floor(n / 1000)) + " Ribu" + terbilang(n % 1000);
  else if (n < 1000000000) hasil = terbilang(Math.floor(n / 1000000)) + " Juta" + terbilang(n % 1000000);
  else if (n < 1000000000000) hasil = terbilang(Math.floor(n / 1000000000)) + " Miliar" + terbilang(n % 1000000000);
  return hasil.trim();
}
